// Dependencies
import React from 'react';

import PropTypes from 'prop-types';

import { Button } from '@nerdwallet/currency';
import { cdnUri } from '@nerdwallet/nw-client-lib/cdn';

import AuthModal from '../../containers/auth-modal';
import CardCta from '../currency/card-cta/card-cta';

import styles from './guide-sign-up-cta.module.less';

const imgUri = cdnUri('img/diy/hac', 'png');

const GuideSignUpCta = ({
  ctaTitle,
  ctaSubtitle,
  flowCopy,
  trackingId,
  impressionPayload,
}) => {
  const flowConfig = {
    slides: [
      {
        copy: flowCopy,
        image: imgUri('house-slider-bg-score'),
      },
      true,
      true,
    ],
  };

  return (
    <CardCta title={ctaTitle} subtitle={ctaSubtitle} trackingId={trackingId}>
      <AuthModal
        flow="basic"
        flowConfig={flowConfig}
        tracking={trackingId}
        impressionPayload={impressionPayload}
      >
        <Button className={styles.joinButton} primary>
          Join NerdWallet
        </Button>
      </AuthModal>
    </CardCta>
  );
};

GuideSignUpCta.propTypes = {
  trackingId: PropTypes.string.isRequired,
  ctaTitle: PropTypes.string,
  ctaSubtitle: PropTypes.string,
  flowCopy: PropTypes.string,
  impressionPayload: PropTypes.object,
};

GuideSignUpCta.defaultProps = {
  ctaTitle: 'Afford the city you want to live in',
  ctaSubtitle:
    'Get free guidance on changes you can make to afford more home, without spending more.',
  flowCopy: 'Get your free home buying guide',
  impressionPayload: {},
};

export default GuideSignUpCta;
